import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class UpdateCertificationInvoiceAllocationDto {
  @Expose()
  certificationId: string;

  @Expose()
  invoiceId: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  allocatedAmount: number;
}
